import { ALL_MODALS } from "../constructor"
import { GetModalParams, ModalType, ModalsState } from "../types.ts"

export const createInitialModalState = (): ModalsState => {
  return ALL_MODALS.reduce((acc, modalType) => {
    acc[modalType as ModalType] = false
    return acc
  }, {} as ModalsState)
}

export const createModalParams = <T extends ModalType>(
  type: T,
  params: GetModalParams<T>
): { type: T; params: GetModalParams<T> } => {
  return { type, params }
}

export const isValidModalType = (type: string): type is ModalType => {
  return ALL_MODALS.includes(type as any)
}
